import Link from 'next/link';
import React from 'react';
import { FiPlus } from 'react-icons/fi';
import ReactTooltip from 'react-tooltip';

import { CONNECTIONS } from '@data/connections';
import useContact from '@hooks/useContact';

const Figure = ({ img }) => (
  <div className="m-5">
    <ReactTooltip
      id={`figure-tooltip-${img.title}`}
      backgroundColor="#282828"
      place="bottom"
      effect="solid"
    />
    <Link href={img.href} as={img.asPath}>
      <a className="focus:outline-none focus:opacity-80">
        <figure
          data-for={`figure-tooltip-${img.title}`}
          data-tip={img.title}
          title={img.title}
          className={`h-16 w-16 rounded-full shadow-header flex items-center justify-center`}
        >
          <img src={img.src} alt={img.title} loading="lazy" />
        </figure>
      </a>
    </Link>
  </div>
);

const Suggest = () => {
  const { show: showContact } = useContact();
  return (
    <div className="m-5">
      <ReactTooltip
        id="suggest-a-database-tooltip"
        backgroundColor="#282828"
        place="bottom"
        effect="solid"
      />
      <button
        data-for="suggest-a-database-tooltip"
        data-tip="Suggest a database"
        className={`h-16 w-16 rounded-full shadow-header flex items-center justify-center bg-blue-100 text-white text-2xl relative`}
        onClick={showContact}
        aria-label="Suggest"
      >
        <FiPlus />
      </button>
    </div>
  );
};

const Connects = ({ title = 'Works with your favorite databases' }) => {
  return (
    <div>
      <p className="text-gray-400 font-inter font-semibold text-sm text-center uppercase">
        {title}
      </p>
      <div className="flex items-center justify-center flex-wrap pt-4 mx-auto max-w-5xl">
        {CONNECTIONS.map((img, index) => (
          <Figure key={`${img.title}-${index}`} img={img} />
        ))}
        <Suggest />
      </div>
    </div>
  );
};

export default Connects;
